var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('main',{staticClass:"auth",attrs:{"role":"main"}},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"d-block-md",staticStyle:{"margin-top":"2%"},attrs:{"md":"6"}}),_c('b-col',{staticClass:"pt-3",attrs:{"xs":"12","md":"6"}},[_vm._t("default")],2)],1)],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }